import { css, styled } from 'styled-components'

type VisibilityAnimationProps = {
  $isVisible: boolean
}

const ANIMATION_DELAY = 0.3 // seconds
const VISIBILITY_ANIMATION = 0.5 // seconds

const visibilityAnimation = css<VisibilityAnimationProps>`
  opacity: ${({ $isVisible }) => ($isVisible ? '1' : '0')};
  transition: opacity
    ${({ $isVisible }) =>
      $isVisible
        ? `${VISIBILITY_ANIMATION}s`
        : `${VISIBILITY_ANIMATION}s ${ANIMATION_DELAY}s`}
    ease;
`

export const StyledContainer = styled.main<VisibilityAnimationProps>`
  position: relative;
  display: flex;
  width: 100%;
  min-height: 100dvh;
  flex-direction: column;
  align-items: center;
  padding-top: ${({ theme }) => theme.sizes.headerHeight}rem;
  ${visibilityAnimation};
`

export const StyledFormContainer = styled.main<VisibilityAnimationProps>`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  padding-top: ${({ theme }) => theme.sizes.headerHeight}rem;
  ${visibilityAnimation};
`

export const StyledForm = styled.form`
  position: relative;
  display: flex;
  width: 100%;
  min-height: calc(100dvh - ${({ theme }) => theme.sizes.headerHeight}rem);
  flex-direction: column;
  align-items: center;
`
